import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { DailyLessonCardKollegeExpenseRecordDailyLessonInputFragmentDoc, DailyLessonCardKollegeUserFragmentDoc } from './DailyLessonCard/DailyLessonCard.generated';
import { DailyLessonStartViewKollegeUserFragmentDoc } from './DailyLessonStartView.generated';
export type DailyLessonViewKollegeUserFragment = { __typename?: 'KollegeUser', id: string, standardCourse?: { __typename?: 'KollegeUserCourse_StandardV20250418', id: string, expenseRecordDailyLesson?: { __typename?: 'KollegeExpenseRecordDailyLesson', guid: string, period?: { __typename?: 'KollegeExpenseRecordDailyLessonPeriod', startsAt: TimeString, endsAt: TimeString } | null, input: Array<{ __typename?: 'KollegeExpenseRecordDailyLessonInput', guid: string, title: string, nth_day: number, instructorComment?: string | null, state: Types.KollegeExpenseRecordDailyLessonInputState }> } | null } | null, profile?: { __typename?: 'KollegeUserProfile', familyName: string, givenName: string } | null };

export const DailyLessonViewKollegeUserFragmentDoc = gql`
    fragment DailyLessonViewKollegeUser on KollegeUser {
  standardCourse {
    expenseRecordDailyLesson {
      guid
      period {
        startsAt
        endsAt
      }
      input {
        ...DailyLessonCardKollegeExpenseRecordDailyLessonInput
      }
    }
  }
  ...DailyLessonStartViewKollegeUser
  ...DailyLessonCardKollegeUser
}
    ${DailyLessonCardKollegeExpenseRecordDailyLessonInputFragmentDoc}
${DailyLessonStartViewKollegeUserFragmentDoc}
${DailyLessonCardKollegeUserFragmentDoc}`;